import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Person, Trash } from 'react-bootstrap-icons';
import './Node.css';

const ForSpecificUsersNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define color scheme
  const colors = {
    container: 'custom-node node-rounded-lg node-border-blue',
    header: 'node-header node-bg-blue-gradient node-border-blue-bottom',
    text: 'node-text-blue',
    handle: 'node-handle-small node-handle-blue'
  };

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`${colors.container} node-hover-lift`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button */}
      <div 
        className={`delete-btn delete-btn.top-center ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className='icon-trash'/>
      </div>

      {/* Header section */}
      <div className={colors.header}>
        <div className="node-header-content">
          <Person className='node-icon' style={{ color: '#3599ab' }}/>
          <span className={`node-title ${colors.text}`}>For Specific Users</span>
        </div>
      </div>

      {/* Output handles */}
      <div className="node-output-handles">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <Handle
            key={`output-${index}`}        
            type="source"
            position={Position.Right}
            id={`output-${index}`}
            className={colors.handle}
            style={{ 
              top: `${((index + 1) * 100) / (outputEdges + 1)}%`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ForSpecificUsersNode; 